import { useMemo, useEffect } from 'react'
import { useProductsStatus } from '../../api/getProductsStatus'
import { CONNECTION_STATE } from 'Types/Product'
import { useGetDomains } from 'Features/domainsManagement/api/getDomains'
import { useLocation } from 'react-router-dom'
import { useGetPackagingLimits } from 'Features/accountSettings/api/getPackagingLimits'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { GLOBAL_MODALS } from 'Types/GlobalModal'
import { useMigrationDisplay } from 'Hooks/useMigrationDisplay'

let productConnectionModalWasOpen = false
const allowedRoutesForPM = ['/', '/domains-management']
const allowedRoutesForBM = ['/botzapping/dashboard']

export const useShowProductConnection = () => {
  const location = useLocation()
  const { setModalToShow, disablePlatformConnectionModal } = useAppStore()
  const { isFirstMigrationLogin } = useMigrationDisplay()
  const { data: packageData } = useGetPackagingLimits()
  const { data: domainData } = useGetDomains()
  const { data: productStatuses } = useProductsStatus()

  const bmDomainAddress = useMemo(
    () =>
      domainData?.data?.domains?.find((domain) => !domain.botZappingConnected && domain.wordpress)
        ?.address || '',

    [domainData?.data.domains]
  )

  /**
   * Paid Marketing Connection Modal
   * open only for the first time
   * open only in allowed routes and only if PM is not connected && PM is allowed
   */
  useEffect(() => {
    if (
      !productConnectionModalWasOpen &&
      !isFirstMigrationLogin &&
      allowedRoutesForPM.includes(location.pathname) &&
      productStatuses?.paidMarketingConnectionStage === CONNECTION_STATE.NOT_CONNECTED &&
      packageData?.paidMarketingAllowed &&
      !disablePlatformConnectionModal
    ) {
      productConnectionModalWasOpen = true
      setModalToShow(GLOBAL_MODALS.PLATFORM_CONNECTION)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    packageData?.paidMarketingAllowed,
    productStatuses?.paidMarketingConnectionStage,
    location.pathname,
  ])

  /**
   * Bot Mitigation Connection Modal
   * open every time enter to allowed routes
   * open only in allowed routes and only if BM is not connected && BM is allowed && wordpress site
   */
  useEffect(() => {
    let hasWordpressSite = false // update in isBotMitigationNotConnected()
    const isBotMitigationNotConnected = () =>
      domainData?.data.domains.every((domain) => {
        if (domain.wordpress) hasWordpressSite = true
        return !domain.botZappingConnected
      })

    if (
      allowedRoutesForBM.includes(location.pathname) &&
      isBotMitigationNotConnected() &&
      hasWordpressSite
    )
      setModalToShow(GLOBAL_MODALS.BM_SETUP)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, domainData?.data.domains])

  return { bmDomainAddress }
}
